import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Sidebar from 'components/shared/sidebar/component';
import { SIDEBAR_MODE_PLAYER } from 'components/constants';
import NewTransaction from 'components/shared/transaction/new/component';
export default function ViewPlayerNewTransaction() {
    var _a = useParams(), type = _a.type, accountId = _a.accountId;
    var navigate = useNavigate();
    var playerId = useSelector(function (state) { return state.player.id; });
    var companyId = useSelector(function (state) { return state.player.company.id; });
    var relevantAccount = type === 'player' ? playerId : companyId;
    var hasInvalidAccountId = !accountId || accountId === 'null' || accountId === 'undefined';
    var currentAccountId = hasInvalidAccountId ? relevantAccount : accountId;
    useEffect(function () {
        if (relevantAccount && (hasInvalidAccountId || accountId !== relevantAccount)) {
            navigate("/money/".concat(type, "/").concat(relevantAccount, "/pay"), { replace: true });
        }
    }, [accountId, hasInvalidAccountId, navigate, relevantAccount, type]);
    return (React.createElement("div", { className: "playerdashboard" },
        React.createElement(Sidebar, { type: SIDEBAR_MODE_PLAYER }),
        React.createElement(NewTransaction, { type: type, accountId: currentAccountId })));
}
